import { Subscription } from 'data/records'
import { resource, findSelector } from 'data/helpers/apiv3'

const [api, actions] = resource(Subscription, [])

const selectors = {
  ...findSelector(Subscription),
  byUserId: (state, userId) => state.apiv3.subscription.id.find(s => s.userId === userId)
}

const initialState = {}

const reducers = {}

export {
  api as subscriptionApi,
  actions as subscriptionActions,
  selectors as subscriptionSelectors,
  reducers as subscriptionReducers,
  initialState as subscriptionInitialState
}
